import { Row, Col } from 'antd';

function PropertyListItem({ name, value, nameStyle, valueStyle }) {
  return (
    <Row style={{ padding: "0.5em" }}>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 5 }}
        md={{ span: 4 }}
        lg={{ span: 3 }}
        style={{ fontWeight: 600, ...nameStyle }}
      >
        {name}
      </Col>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 19 }}
        md={{ span: 20 }}
        lg={{ span: 21 }}
        style={{ ...valueStyle }}
      >
        {value}
      </Col>
    </Row >
  )
}

export default PropertyListItem;
